import { Injectable } from "@angular/core";
import { apiUrl } from "@telespot/shared/environment";

@Injectable({
  providedIn: "root",
})
export class AssetFileService {
  getThumbnailUrl(assetFile) {
    const imageRegex = /.(png|bmp|jpg|jpeg|dcm)$/gim;
    const videoRegex = /.(mp4|mov|avi|mpeg)$/gim;
    const fileName = encodeURI(assetFile.substr(0, assetFile.lastIndexOf(".")));
    return imageRegex.test(assetFile)
      ? `${apiUrl('pyramids')}/${fileName}/thumbnail`
      : videoRegex.test(assetFile)
      ? `${apiUrl('videos')}/${fileName}/thumbnail`
      : `@app/assets/media/image_placeholder.svg`;
  }
}
